<template>
  <div class="customerOrderDetailPage">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane :label="'审批信息'" name="base">
        <review-table
          ref="reviewTable"
          :changeOrderCode="params.code"
          :disabled="isDisableEditForm"
          @saveOkQuestion="saveOkQuestion"
        />
        <el-card :body-style="{ padding: '20px' }">
          <div style="height:550px;overflow:auto">
            <el-row :gutter="20">
              <el-col :span="24" v-for="(item, index) in dataList" :key="index">
                <el-card class="mt-2">
                  <h5>
                    <b>{{ item.title }}</b>
                  </h5>

                  <el-col
                    :span="24"
                    v-for="(datas, index) in item.childrenDataOne"
                    :key="index"
                  >
                    <h6>
                      <b> {{ datas.title }}</b>
                    </h6>

                    <ol>
                      <li
                        v-for="(threeData, index) in datas.childrenDataTwo"
                        :key="index"
                      >
                        <span> {{ threeData.title }} </span>
                        <ul
                          v-for="(threeList,
                          index) in threeData.childrenDataThreeList"
                          :key="index"
                        >
                          <li
                            v-for="(fourData, index) in threeList"
                            :key="index"
                          >
                            <span>
                              {{
                                fourData.title ? fourData.title : fourData
                              }}</span
                            >
                            <ul
                              v-for="(fiveData,
                              index) in fourData.childrenListFour"
                              :key="index"
                            >
                              <li>
                                {{ fiveData.childrenName }}
                                <ul
                                  v-for="(sixData,
                                  index) in fiveData.childrenSpecData"
                                  :key="index"
                                >
                                  <li>{{ sixData }}</li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </el-col>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-tab-pane>

      <el-tab-pane :label="'订单信息'" name="order">
        <ChangeOrder :code="params.code" :isDisableEditForm="true" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ReviewTable from './change-order-review'
import ChangeOrder from './change-order.vue'
import { mapActions } from 'vuex'
export default {
  name: 'order-changeOrderConfirmDetail',
  components: { ChangeOrder, ReviewTable },
  data() {
    return {
      activeName: 'base',
      tableData: [],
      dataList: [],
    }
  },
  beforeMount() {
    this.getChangeOrder()
  },
  computed: {
    params() {
      return this.$route.params
    },
    query() {
      return this.$route.query
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getChangeOrder() {
      this.$api
        .changeOrderListGetChangeContentApi({
          changeOrderCode: this.params.code,
        })
        .then((res) => {
          this.tableData = JSON.parse(res.body)
          const array = this.sortClass(this.tableData)
          array.forEach((m) => {
            this.filterData(m, m[0].functionName)
          })
        })
        .catch(() => {})
    },
    filterData(selected, title) {
      let data = { title: '', childrenDataOne: [] }
      data.title = title
      let addData = { title: '新增', childrenDataTwo: [] }
      let updateData = { title: '修改', childrenDataTwo: [] }
      let deleteData = { title: '删除', childrenDataTwo: [] }
      for (let index = 0; index < selected.length; index++) {
        let childrenDataThree = { title: '', childrenDataThreeList: [] }
        const iterator = selected[index]

        const detailList = iterator.functionDetail
        let childrenList = []
        let childrenListFour = []
        if (detailList && detailList.length > 0) {
          for (let index = 0; index < detailList.length; index++) {
            const detail = detailList[index]
            childrenList.push(
              detail.fieldName +
                ': ' +
                (detail.oldFieldContent || '""') +
                '--->' +
                detail.newFieldContent
            )
          }
        }
        const children = iterator.childrenList

        if (children && children.length > 0) {
          for (let index = 0; index < children.length; index++) {
            let childrenSpecData = []

            const detail = children[index]

            if (detail.functionDetail && detail.functionDetail.length > 0) {
              for (
                let index = 0;
                index < detail.functionDetail.length;
                index++
              ) {
                const childrenDetail = detail.functionDetail[index]

                childrenSpecData.push(
                  childrenDetail.fieldName +
                    ': ' +
                    (childrenDetail.oldFieldContent || '""') +
                    '--->' +
                    childrenDetail.newFieldContent
                )
              }
            }
            childrenListFour.push({
              childrenSpecData,
              childrenName: detail.childrenName,
            })
          }
          childrenList.push({
            title: children[0].functionName,
            childrenListFour: childrenListFour,
          })
        }

        childrenDataThree.title = iterator.mainName
        childrenDataThree.childrenDataThreeList.push(childrenList)

        if ('add' == iterator.changeType) {
          addData.title = '新增'
          addData.childrenDataTwo.push(childrenDataThree)
        }
        if ('update' == iterator.changeType) {
          updateData.title = '修改'
          updateData.childrenDataTwo.push(childrenDataThree)
        }
        if ('delete' == iterator.changeType) {
          deleteData.title = '删除'
          deleteData.childrenDataTwo.push(childrenDataThree)
        }
      }
      if (addData.childrenDataTwo.length > 0) {
        data.childrenDataOne.push(addData)
      }
      if (updateData.childrenDataTwo.length > 0) {
        data.childrenDataOne.push(updateData)
      }
      if (deleteData.childrenDataTwo.length > 0) {
        data.childrenDataOne.push(deleteData)
      }

      this.dataList.push(data)
    },
    sortClass(sortData) {
      const groupBy = (array, f) => {
        let groups = {}
        array.forEach((o) => {
          let group = JSON.stringify(f(o))
          groups[group] = groups[group] || []
          groups[group].push(o)
        })
        return Object.keys(groups).map((group) => {
          return groups[group]
        })
      }
      const sorted = groupBy(sortData, (item) => {
        return item.functionName // 返回需要分组的对象
      })
      return sorted
    },

    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
